import React, { useState } from 'react';
import MetadataManager from '../../components/MetadataManager'; // Your existing component
import VideoManager from '../../components/VideoManager'; // The new component

function App() {
    const [activeTab, setActiveTab] = useState('metadata');
    const [apiKey, setApiKey] = useState('');
    const [selectedCharacter, setSelectedCharacter] = useState('missy');

    const TabButton = ({ tabName, label }) => (
        <button
            onClick={() => setActiveTab(tabName)}
            className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                activeTab === tabName 
                ? 'bg-indigo-100 text-indigo-700' 
                : 'text-gray-500 hover:text-gray-700'
            }`}
        >
            {label}
        </button>
    );

    return (
        <div className="bg-gray-100 min-h-screen antialiased">
            <div className="container mx-auto px-4 py-8">
                <main className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-6 sm:p-8">
                    {/* Header */}
                    <div className="mb-8">
                        <h1 className="text-3xl font-bold text-gray-800">Admin Dashboard</h1>
                        <p className="text-gray-500 mt-1">Manage character metadata and video files.</p>
                    </div>

                    {/* Section 1: Configuration */}
                    <section className="mb-8">
                        <h2 className="text-xl font-semibold text-gray-700">Configuration</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                            <div>
                                <label htmlFor="character" className="block text-sm font-medium text-gray-700">Character</label>
                                <select id="character" value={selectedCharacter} onChange={(e) => setSelectedCharacter(e.target.value)}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
                                    <option value="missy">Missy Smith</option>
                                </select>
                            </div>
                            <div>
                                <label htmlFor="api-key" className="block text-sm font-medium text-gray-700">API Key</label>
                                <input type="password" id="api-key" value={apiKey} onChange={(e) => setApiKey(e.target.value)}
                                    placeholder="Enter your API key"
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" />
                            </div>
                        </div>
                    </section>

                    {/* Tab Navigation */}
                    <div className="border-b border-gray-200 mb-6">
                        <nav className="-mb-px flex space-x-4" aria-label="Tabs">
                            <TabButton tabName="metadata" label="Metadata Manager" />
                            <TabButton tabName="videos" label="Video Manager" />
                        </nav>
                    </div>

                    {/* Tab Content */}
                    <div>
                        {activeTab === 'metadata' && (
                            <MetadataManager character={selectedCharacter} apiKey={apiKey} />
                        )}
                        {activeTab === 'videos' && (
                            <VideoManager character={selectedCharacter} apiKey={apiKey} />
                        )}
                    </div>
                </main>
            </div>
        </div>
    );
}

export default App;